import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

interface AIMatchedJob {
  id: string;
  title: string;
  company: {
    name: string;
    logo_url?: string;
  };
  location: string;
  job_type: string;
  experience_level: string;
  salary_min?: number;
  salary_max?: number;
  currency: string;
  is_remote: boolean;
  featured: boolean;
  created_at: string;
  matchScore: number;
}

export const useAIMatchedJobs = () => {
  const [jobs, setJobs] = useState<AIMatchedJob[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuth();

  const fetchAIMatchedJobs = async () => {
    if (!user) {
      setError('User not authenticated');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { data, error } = await supabase.functions.invoke('ai-match-jobs');
      
      if (error) {
        throw new Error(error.message || 'Failed to fetch AI matched jobs');
      }

      setJobs(data.jobs || []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
      console.error('Error fetching AI matched jobs:', err);
    } finally {
      setLoading(false);
    }
  };

  return {
    jobs,
    loading,
    error,
    fetchAIMatchedJobs
  };
};